var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePictureUploadThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.143 46.285h37.714a3.429 3.429 0 0 0 3.429-3.428V5.142a3.429 3.429 0 0 0-3.429-3.428H5.143a3.429 3.429 0 0 0-3.429 3.428v37.715a3.429 3.429 0 0 0 3.429 3.428ZM1.714 37.714h44.572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.166 37.714 17.863-16.732a1.714 1.714 0 0 1 2.194 0l13.063 9.36M15.428 20.57a5.143 5.143 0 1 0 0-10.285 5.143 5.143 0 0 0 0 10.286Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePictureUploadThin);
export default __webpack_public_path__ + "static/media/image-picture-upload-thin.03058d53fa8e8596b6da90543869b490.svg";
export { ForwardRef as ReactComponent };